import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Swiper, SwiperSlide } from "swiper/react";
import HomeHeaderService from "../../../services/HomeHeaderService";
import { useSelector } from "react-redux";
import BannerService from "../../../services/BannerService";
import "./style.css";
import { useNavigate } from "react-router-dom";
import { Autoplay, Scrollbar } from "swiper/modules";

const Banner = () => {
	const lang = useSelector((state) => state.lang.lang);
	const navigate = useNavigate();
	const [formData, setFormData] = useState({
		link: "",
		title_en: "",
		title_ar: "",
		description_en: "",
		description_ar: "",
	});
	const [loading, setLoading] = useState(false);
	const [data, setData] = useState("");
	const [clients, setClients] = useState([]);
	const { t } = useTranslation();
	const homeHeaderService = new HomeHeaderService();

	useEffect(() => {
		setLoading(true);
		Promise.all([
			homeHeaderService.getList("header"),
			homeHeaderService.getList("client"),
			new BannerService().getList("header"),
		])
			.then((res) => {
				if (res[0].status === 200) {
					let response = res[0]?.data?.data?.data;
					if (!!response?.length) {
						setFormData({
							title_en: response[0].title_en,
							title_ar: response[0].title_ar,
							description_en: response[0].description_en,
							description_ar: response[0].description_ar,
							link: response[0].link,
						});
					}
				}
				if (res[1].status === 200) {
					let response = res[1]?.data?.data;
					if (!!response?.length) {
						setClients(response?.map((img) => img?.image));
					}
				}
				if (res[2]?.status === 200) {
					if (!!res[2]?.data?.data?.banner_images?.length)
						setData(res[2]?.data?.data?.banner_images[0]?.url);
				}
				setLoading(false);
			})
			.catch(() => setLoading(false));
	}, []);

	if (loading) {
		return (
			<div className="banner banner-loading">
				<div className="placeholder"></div>
			</div>
		);
	}
	return (
		<div className="banner">
			<div className="shadow"></div>
			<img src={data} alt="banner" className="banner-image" />
			<div className="banner-titles">
				<p
					className="main-title"
					dangerouslySetInnerHTML={{
						__html: formData[`title_${lang}`],
					}}></p>
				<p
					className="description"
					dangerouslySetInnerHTML={{
						__html: formData[`description_${lang}`],
					}}></p>
				<span
					onClick={() => navigate(`/${formData?.link}`)}
					className="discover">
					{t("Discover Who We Are")}
				</span>
			</div>
			<div className="banner-swiper">
				<div className="custom-height-for-banner"></div>
				<Swiper
					slidesPerView={3}
					spaceBetween={20}
					pagination={{
						clickable: true,
					}}
					modules={[Autoplay]}
					breakpoints={{
						640: {
							slidesPerView: 3,
							spaceBetween: 10,
						},
						768: {
							slidesPerView: 4,
							spaceBetween: 15,
						},
						1024: {
							slidesPerView: 5,
							spaceBetween: 15,
						},
					}}
					loop={true}
					autoplay={{
						delay: 3000, // 3 seconds
						disableOnInteraction: false, // keeps autoplay even if user interacts
					}}
					className="mySwiper">
					{clients?.map((sponser, index) => {
						return (
							<SwiperSlide key={index}>
								<img src={sponser} alt="sponser" />
							</SwiperSlide>
						);
					})}
				</Swiper>
			</div>
		</div>
	);
};
export default Banner;
